type MobileLogoComponentPropsType = {
  className?: string;
};

function MobileLogoComponent({ className }: MobileLogoComponentPropsType) {
  return <img alt="logo" className={className} src="/logo.png" />;
}
export default MobileLogoComponent;
